module.exports = __webpack_public_path__ + "static/media/team5.c8e3f820.jpg";